import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const FraudDetectionRBAC = {
  pageID: '38e478f22ab5268780a9e9f2697fa1a2',
  elementID: {
    View: 'd111f86ffa8d922820523b7ee6708f45',
    CancelOrder: 'c7cf7e022afca97f65a547bff8add204',
    ApproveOrder: '1abbb6d5e9fec442922bb708654d465b',
  },
} as const

export const useFraudDetectionRBACRBACPage = createUseRBAC(FraudDetectionRBAC.elementID)

export type UseFraudDetectionRBACRBACPageType = ReturnType<typeof useFraudDetectionRBACRBACPage>
